import { createCompositeMediaInlineCaption } from "./caption.js";
import { createCompositeMediaInlineStandard } from "./standard.js";
import { createCompositeMediaInlineWrapped } from "./wrapped.js";
const createCompositeMediaInline = {
  caption: createCompositeMediaInlineCaption,
  standard: createCompositeMediaInlineStandard,
  wrapped: createCompositeMediaInlineWrapped
};
export {
  createCompositeMediaInline
};
//# sourceMappingURL=index.js.map
